export * from '@lexical/react/LexicalAutoEmbedPlugin'
